import { telemetry } from './telemetry';
// import { intercomService } from './intercom.service';
import { consoleService } from './console.service';
import { segmentService } from './segment.service';

export const instantiateTelemetry = () => {
  telemetry.registerServices([consoleService, segmentService]);
  telemetry.initServices();
};
